// src/utils/device.ts 检测设备是否移动设备并且实时读取屏幕容器的宽度和高度
import { ref } from "vue";
import { UAParser } from "ua-parser-js";

export const createDeviceDetector = () => {
    const screenWidth = ref(window.innerWidth);
    const screenHeight = ref(window.innerHeight);
    const isMobile = ref(false);

    const initDeviceType = () => {
        const parser = new UAParser();
        const device = parser.getDevice();
        isMobile.value = screenWidth.value < 768 && device.type === "mobile";
    };

    const updateScreenSize = () => {
        screenWidth.value = window.innerWidth;
        screenHeight.value = window.innerHeight;
    };

    return {
        screenWidth,
        screenHeight,
        isMobile,
        initDeviceType,
        updateScreenSize
    };
};

